import { JSX } from 'react';
import { tv } from 'tailwind-variants';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';

export type FormInfoProps = {
  heading?: string;
  content?: string;
};

const FieldInfo = ({ heading, content }: FormInfoProps): JSX.Element | null => {
  if (!heading && !content) return null;

  const { fieldInfoWrapper, fieldInfoHeading, fieldInfoContent } = TAILWIND_VARIANTS();
  return (
    <div className={fieldInfoWrapper()}>
      <PlainTextWrapper field={{ value: heading }} tag="h2" className={fieldInfoHeading()} />
      <RichTextWrapper
        field={{
          value: content,
        }}
        className={fieldInfoContent()}
      />
    </div>
  );
};

export default FieldInfo;
const TAILWIND_VARIANTS = tv({
  slots: {
    fieldInfoWrapper: ['w-full', 'flex flex-col gap-spacing-spacing-12'],
    fieldInfoHeading: [
      'font-typography-font-family-body',
      'text-component-section-title',
      'text-typography-font-size-h5',
      'font-semibold',
      'leading-ypography-line-height-h5',
    ],
    fieldInfoContent: [
      '[&>*]:!font-typography-font-family-body',
      '[&>*]:!text-p-color-text',
      '[&>*]:!text-typography-font-size-body-medium',
      '[&>*]:!leading-typography-line-height-body-medium',
    ],
  },
});
